import { create } from "zustand"

export type Density = "compact" | "comfortable" | "spacious"

const STORAGE_KEY = "nexus_display"

interface DisplayState {
  density: Density
  setDensity: (density: Density) => void
}

function readDensity(): Density {
  try {
    const stored = localStorage.getItem(STORAGE_KEY) as Density | null
    if (stored === "compact" || stored === "comfortable" || stored === "spacious") {
      return stored
    }
    return "comfortable"
  } catch {
    return "comfortable"
  }
}

export const useDisplayStore = create<DisplayState>((set) => ({
  density: readDensity(),
  setDensity: (density) => {
    try {
      localStorage.setItem(STORAGE_KEY, density)
    } catch { /* SSR / incognito fallback */ }
    set({ density })
  },
}))
